<div class="app-audit-entry" [ngClass]="customClass">
  <!-- Form Label UI -->
  <app-label
    *ngIf="label"
    [text]="label"
    [mandatory]="mandatory"
    [optional]="optional"
  ></app-label>

  <!-- Form Element Container -->
  <div
    class="app-audit-entry__card"
    [class.app-audit-entry__card--focused]="isFocused"
    [class.app-audit-entry__card--disabled]="disabled"
  >
    <textarea
      #textareaRef
      class="app-audit-entry__textarea"
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      [rows]="rows"
      (input)="onInput($event)"
      (focus)="isFocused = true"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
    ></textarea>

    <div class="app-audit-entry__footer">
      <app-button
        variant="primary"
        size="compact"
        [disabled]="disabled || !value || value.trim().length === 0"
        [loading]="loading"
        [fullWidth]="false"
        (btnClick)="onSubmit()"
      >
        <span class="app-audit-entry__btn-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
            class="app-audit-entry__btn-icon"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
          <span>{{ buttonText }}</span>
        </span>
      </app-button>
    </div>
  </div>
</div>
